export const sessionResourceType = "session" as const;
export const sessionResourcePath = "/session" as const;
